<div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
  <div class="flex flex-column align-items-center justify-content-center">
    <div style="border-radius:56px; padding:0.3rem; background: linear-gradient(180deg, #45367A 10%, #A7A8AC 30%);">
      <div class="w-full surface-card py-8 px-5 sm:px-8 flex flex-column align-items-center" style="border-radius:53px">
        <div class="grid flex flex-column align-items-center">
          <div class="flex justify-content-center align-items-center border-circle"
            style="width:3.2rem; height:3.2rem; background-color: #45367A;">
            <i class="text-50 pi pi-fw pi-lock text-2xl"></i>
          </div>
          <h1 class="text-900 font-bold text-4xl lg:text-5xl mb-2">Acceso denegado</h1>
          <span class="text-600 mb-5">Tú no tienes permisos para acceder a esta página. Por favor comunicarse con el
            administrador de la plataforma</span>
        </div>
      </div>
    </div>
  </div>
</div>